import script from "./LoadingAnimation3.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingAnimation3.vue?vue&type=script&setup=true&lang=js"

import "./LoadingAnimation3.vue?vue&type=style&index=0&id=3c5c61e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c5c61e4"]])

export default __exports__